import { Component, OnInit } from '@angular/core'
import { NgForm } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { AlertService } from '../../../common/alert/shared/alert.service'
import { OperadoraDeMaquina } from '../../../pkw-data/collect/operadora-de-maquina.model'
import { Configuracao } from '../../../pkw-data/core/configuracao/configuracao.model'
import {
    ConfiguracaoIntegracaoOperadora,
    ValorIntegracaoConciliadorWCONT
} from '../../shared/configuracao-integracao-operadora'
import { Operador } from '../../../pkw-data/core/operador.model'
import { OperadorService } from '../../../core/services/operador.service'

@Component({
    selector: 'col-configuracao-integracao-operadora',
    templateUrl: './configuracao-integracao-operadora.component.html'
})
export class ConfiguracaoIntegracaoOperadoraComponent implements OnInit {
    configuracoesOperadora: ConfiguracaoIntegracaoOperadora[]

    private operadoras: OperadoraDeMaquina[]
    private configuracao: Configuracao
    private valor: ValorIntegracaoConciliadorWCONT

    operador: Operador

    constructor(private route: ActivatedRoute, private alertService: AlertService,
                private operadorService: OperadorService) {}

    ngOnInit() {
        const routeData = this.route.parent.snapshot
            .data as ConfiguracaoIntegracaoComponentRouteData
        const todasOperadoras = routeData.todasOperadoras
        const operadorasComEstabelecimento = routeData.operadorasComEstabelecimento

        this.configuracao = routeData.configuracao
        this.initConfiguracoes(todasOperadoras, operadorasComEstabelecimento)

        this.operadorService.corrente.subscribe(operador => {
            this.operador = operador
        })
    }

    salvar(form: NgForm) {
        if (form.valid) {
            this.atualizarValorConfiguracao()
            this.configuracao
                .save()
                .subscribe(() =>
                    this.alertService.info('Configurações atualizadas!', 'Aviso')
                )
        }
    }

    private initConfiguracoes(
        todasOperadoras: OperadoraDeMaquina[],
        operadorasComEstabelecimento: OperadoraDeMaquina[]
    ) {
        this.valor = this.configuracao.getValor<ValorIntegracaoConciliadorWCONT>()

        const codigosDeConfigsPorOperadora = this.valor.CodigosContabeis.filter(
            codigos => codigos.NomeDaOperadora && !codigos.Bandeira
        )

        this.operadoras = todasOperadoras.filter(e => e.ativo).filter(
            operadora =>
                operadorasComEstabelecimento.some(operadoraComEstabelecimento => operadoraComEstabelecimento.cnpj === operadora.cnpj) ||
                codigosDeConfigsPorOperadora.some(codigoDeConfigsPorOperadora => codigoDeConfigsPorOperadora.NomeDaOperadora === operadora.nome)
        )
        this.configuracoesOperadora = this.operadoras.map(operadora => {
            const codigos = codigosDeConfigsPorOperadora.find(
                c => !c.Bandeira && c.NomeDaOperadora === operadora.nome
            )

            return new ConfiguracaoIntegracaoOperadora(operadora, codigos)
        })
    }

    private atualizarValorConfiguracao() {
        const codigosDeConfigsPorBandeira = this.valor.CodigosContabeis.filter(
            codigos => codigos.NomeDaOperadora && codigos.Bandeira
        )
        const codigosDeConfigsPorOperadora = this.configuracoesOperadora.map(
            config => config.codigos
        )
        this.valor.CodigosContabeis = codigosDeConfigsPorOperadora.concat(
            codigosDeConfigsPorBandeira
        )
        this.configuracao.setValor(this.valor)
    }

    collectPermissaoSalvar(){          
            return this.operador.tipo === "COLABORADOR" && 
                   (this.operador.UsaCollect().Criar || 
                    this.operador.UsaCollect().Editar ||
                    this.operador.UsaCollect().Excluir) === true ? true : false    
      }
}

interface ConfiguracaoIntegracaoComponentRouteData {
    todasOperadoras: OperadoraDeMaquina[]
    operadorasComEstabelecimento: OperadoraDeMaquina[]
    configuracao: Configuracao
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao-operadora/configuracao-integracao-operadora.component.ts